module.exports = __webpack_public_path__ + "prj_02.a7e6d808.jpeg";